/**
 * Header V2 — Mega Menu hover interactions
 * Handles hover-based mega menu display with delay for UX
 */
(function() {
  'use strict';

  const HOVER_DELAY_IN = 150;  // ms before showing
  const HOVER_DELAY_OUT = 300; // ms before hiding

  document.addEventListener('DOMContentLoaded', function() {
    const megamenuTriggers = document.querySelectorAll('[data-megamenu-trigger]');

    megamenuTriggers.forEach(function(trigger) {
      let showTimeout = null;
      let hideTimeout = null;

      function showMegamenu() {
        clearTimeout(hideTimeout);
        hideTimeout = null;

        // Hide all other megamenus first
        megamenuTriggers.forEach(function(other) {
          if (other !== trigger) {
            other.classList.remove('is-active');
          }
        });

        showTimeout = setTimeout(function() {
          trigger.classList.add('is-active');
        }, HOVER_DELAY_IN);
      }

      function hideMegamenu() {
        clearTimeout(showTimeout);
        showTimeout = null;

        hideTimeout = setTimeout(function() {
          trigger.classList.remove('is-active');
        }, HOVER_DELAY_OUT);
      }

      trigger.addEventListener('mouseenter', showMegamenu);
      trigger.addEventListener('mouseleave', hideMegamenu);

      // Keep megamenu open when hovering over it
      const megamenu = trigger.querySelector('.header-v2__megamenu');
      if (megamenu) {
        megamenu.addEventListener('mouseenter', function() {
          clearTimeout(hideTimeout);
          hideTimeout = null;
        });
        megamenu.addEventListener('mouseleave', hideMegamenu);
      }

      // Keyboard accessibility — open on Space, navigate on Enter, close on Escape
      const triggerLink = trigger.querySelector('a.header-v2__primary-nav-link, a.header-v2-condensed__link');
      if (triggerLink) {
        triggerLink.setAttribute('aria-expanded', 'false');
        triggerLink.setAttribute('aria-haspopup', 'true');

        triggerLink.addEventListener('keydown', function(e) {
          if (e.key === ' ') {
            // Space toggles the megamenu without navigating
            e.preventDefault();
            const isOpen = trigger.classList.contains('is-active');
            if (isOpen) {
              trigger.classList.remove('is-active');
              triggerLink.setAttribute('aria-expanded', 'false');
            } else {
              // Close others
              megamenuTriggers.forEach(function(other) {
                other.classList.remove('is-active');
                const otherTrigger = other.querySelector('[aria-expanded]');
                if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
              });
              trigger.classList.add('is-active');
              triggerLink.setAttribute('aria-expanded', 'true');
            }
          }

          // Enter key: allow default <a> navigation (do not preventDefault)

          if (e.key === 'Escape') {
            trigger.classList.remove('is-active');
            triggerLink.setAttribute('aria-expanded', 'false');
            triggerLink.focus();
          }
        });
      }
    });

    // Close all megamenus when clicking outside
    document.addEventListener('click', function(e) {
      if (!e.target.closest('[data-megamenu-trigger]')) {
        megamenuTriggers.forEach(function(trigger) {
          trigger.classList.remove('is-active');
          const triggerLink = trigger.querySelector('[aria-expanded]');
          if (triggerLink) triggerLink.setAttribute('aria-expanded', 'false');
        });
      }
    });

    // Close megamenus on Escape anywhere
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        megamenuTriggers.forEach(function(trigger) {
          trigger.classList.remove('is-active');
          const triggerLink = trigger.querySelector('[aria-expanded]');
          if (triggerLink) triggerLink.setAttribute('aria-expanded', 'false');
        });
      }
    });

    // Close search predictions when clicking outside the search area
    document.addEventListener('click', function(e) {
      // Desktop search
      var searchContainer = document.querySelector('.header-v2__search');
      if (searchContainer && !searchContainer.contains(e.target)) {
        var emptyState = searchContainer.querySelector('.search-empty-state');
        var predictiveResults = searchContainer.querySelector('.predictive-search');
        if (emptyState) emptyState.classList.add('hidden');
        if (predictiveResults) predictiveResults.classList.add('close_searchh');
        var predictiveEl = searchContainer.querySelector('predictive-search');
        if (predictiveEl) {
          predictiveEl.removeAttribute('open');
          var input = predictiveEl.querySelector('input[type="search"]');
          if (input) input.setAttribute('aria-expanded', 'false');
        }
      }

      // Mobile page search
      var mobilePageSearch = document.querySelector('.header-v2-mobile__page-search');
      if (mobilePageSearch && !mobilePageSearch.contains(e.target)) {
        var mEmptyState = mobilePageSearch.querySelector('.search-empty-state');
        var mPredictive = mobilePageSearch.querySelector('.predictive-search');
        if (mEmptyState) mEmptyState.classList.add('hidden');
        if (mPredictive) mPredictive.classList.add('close_searchh');
        var mPredictiveEl = mobilePageSearch.querySelector('predictive-search');
        if (mPredictiveEl) {
          mPredictiveEl.removeAttribute('open');
          var mInput = mPredictiveEl.querySelector('input[type="search"]');
          if (mInput) mInput.setAttribute('aria-expanded', 'false');
        }
      }

      // Mobile drawer search
      var mobileDrawerSearch = document.querySelector('.header-v2-mobile__drawer-search');
      if (mobileDrawerSearch && !mobileDrawerSearch.contains(e.target)) {
        var dEmptyState = mobileDrawerSearch.querySelector('.search-empty-state');
        var dPredictive = mobileDrawerSearch.querySelector('.predictive-search');
        if (dEmptyState) dEmptyState.classList.add('hidden');
        if (dPredictive) dPredictive.classList.add('close_searchh');
        var dPredictiveEl = mobileDrawerSearch.querySelector('predictive-search');
        if (dPredictiveEl) {
          dPredictiveEl.removeAttribute('open');
          var dInput = dPredictiveEl.querySelector('input[type="search"]');
          if (dInput) dInput.setAttribute('aria-expanded', 'false');
        }
      }
    });

    // Mobile page search — remove drawer-open behavior
    
    // Patch PredictiveSearch open/close to handle instances without specific IDs
    document.querySelectorAll('predictive-search').forEach(function(ps) {
      var originalOpen = ps.open;
      if (originalOpen) {
        ps.open = function() {
          originalOpen.call(this);
          // Fallback: if close_searchh wasn't removed by ID-based logic, remove it directly
          var predictiveDiv = this.querySelector('[data-predictive-search]');
          if (predictiveDiv) {
            predictiveDiv.classList.remove('close_searchh');
          }
        };
      }
    });

    // Clear search and close preview when native clear button (X) is pressed
    document.querySelectorAll('predictive-search input[type="search"]').forEach(function(input) {
      input.addEventListener('search', function() {
        // 'search' event fires when the native X clear button is clicked
        if (input.value === '') {
          var ps = input.closest('predictive-search');
          if (ps) {
            var predictiveDiv = ps.querySelector('[data-predictive-search]');
            var emptyState = ps.querySelector('.search-empty-state');
            if (predictiveDiv) predictiveDiv.classList.add('close_searchh');
            if (emptyState) emptyState.classList.add('hidden');
            ps.removeAttribute('open');
            input.setAttribute('aria-expanded', 'false');
          }
        }
      });
    });

    // ====== MOBILE DRAWER NAVIGATION ======
    var drawer = document.querySelector('[data-mobile-drawer]');
    var overlay = document.querySelector('[data-mobile-menu-overlay]');
    var openBtns = document.querySelectorAll('[data-mobile-menu-open]');
    var closeBtns = document.querySelectorAll('[data-mobile-menu-close]');

    function openDrawer() {
      if (drawer) drawer.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      // Focus the first focusable element in drawer
      if (drawer) {
        var firstFocusable = drawer.querySelector('button, a, input');
        if (firstFocusable) setTimeout(function() { firstFocusable.focus(); }, 100);
      }
    }

    var lastFocusedElement = null;

    function closeDrawer() {
      if (drawer) drawer.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      document.body.style.overflow = '';
      // Return focus to trigger
      if (lastFocusedElement) {
        lastFocusedElement.focus();
        lastFocusedElement = null;
      }
      // Reset to main panel
      setTimeout(function() {
        var panels = drawer.querySelectorAll('.header-v2-mobile__panel');
        panels.forEach(function(panel) {
          panel.classList.remove('header-v2-mobile__panel--active', 'header-v2-mobile__panel--exiting');
        });
        var mainPanel = drawer.querySelector('[data-panel="main"]');
        if (mainPanel) mainPanel.classList.add('header-v2-mobile__panel--active');
      }, 300);
    }

    openBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        lastFocusedElement = btn;
        openDrawer();
      });
    });

    closeBtns.forEach(function(btn) {
      btn.addEventListener('click', closeDrawer);
    });

    // Close drawer on Escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) {
        closeDrawer();
      }
    });

    if (overlay) {
      overlay.addEventListener('click', closeDrawer);
    }

    // Panel navigation (drill-down)
    var panelButtons = document.querySelectorAll('[data-open-panel]');
    panelButtons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var targetPanelId = btn.getAttribute('data-open-panel');
        var targetPanel = drawer.querySelector('[data-panel="' + targetPanelId + '"]');
        var currentPanel = drawer.querySelector('.header-v2-mobile__panel--active');

        if (targetPanel && currentPanel && targetPanel !== currentPanel) {
          // Animate current panel out to the left
          currentPanel.classList.add('header-v2-mobile__panel--exiting');
          currentPanel.classList.remove('header-v2-mobile__panel--active');
          
          // Animate new panel in from the right
          targetPanel.classList.add('header-v2-mobile__panel--active');

          // Clean up after transition
          setTimeout(function() {
            currentPanel.classList.remove('header-v2-mobile__panel--exiting');
          }, 400);
        }
      });
    });

    // Back button navigation
    var backButtons = document.querySelectorAll('[data-panel-back]');
    backButtons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var backTo = btn.getAttribute('data-panel-back');
        var targetPanel;
        if (backTo && backTo !== '') {
          targetPanel = drawer.querySelector('[data-panel="' + backTo + '"]');
        } else {
          targetPanel = drawer.querySelector('[data-panel="main"]');
        }
        var currentPanel = btn.closest('.header-v2-mobile__panel');

        if (targetPanel && currentPanel && targetPanel !== currentPanel) {
          // Going back: current slides out to right, target slides in from left
          currentPanel.classList.remove('header-v2-mobile__panel--active');
          
          // Target needs to come from the left (it was exiting to -25%)
          targetPanel.style.transform = 'translateX(-25%)';
          targetPanel.classList.add('header-v2-mobile__panel--active');
          
          // Force reflow then animate to center
          requestAnimationFrame(function() {
            requestAnimationFrame(function() {
              targetPanel.style.transform = '';
            });
          });
        }
      });
    });

    // ====== MOBILE ACCORDION (inline subcategory expand) ======
    var accordionToggles = document.querySelectorAll('.header-v2-mobile__accordion-toggle');
    accordionToggles.forEach(function(toggle) {
      toggle.addEventListener('click', function() {
        var content = toggle.nextElementSibling;
        var isExpanded = toggle.getAttribute('aria-expanded') === 'true';

        if (isExpanded) {
          toggle.setAttribute('aria-expanded', 'false');
          content.classList.remove('is-open');
        } else {
          toggle.setAttribute('aria-expanded', 'true');
          content.classList.add('is-open');
        }
      });
    });

    // ====== CONDENSED NAV (scroll-triggered) ======
    var condensedNav = document.querySelector('[data-condensed-nav]');
    if (condensedNav) {
      var lastScrollY = window.scrollY;
      var upwardDistance = 0;
      var scrollThreshold = 50; // px of upward scroll before showing
      var isHomepage = document.body.classList.contains('template--index');
      var isCollection = document.body.classList.contains('template--collection');
      var isProduct = document.body.classList.contains('template--product');
      var isListingPage = isCollection || document.body.classList.contains('template--search');

      // Product pages (DESKTOP ONLY): condensed nav replaces the full header
      // and is always visible. Small screens keep the original scroll behavior.
      var pdpDesktopMQ = window.matchMedia('(min-width: 1025px)');

      function applyPdpCondensed() {
        if (isProduct && pdpDesktopMQ.matches) {
          condensedNav.classList.add('is-visible');
          document.body.classList.add('condensed-nav-visible');
          document.body.classList.add('pdp-condensed-only');
        } else if (isProduct) {
          // Below desktop: remove the forced state so scroll logic can take over
          document.body.classList.remove('pdp-condensed-only');
          condensedNav.classList.remove('is-visible');
          document.body.classList.remove('condensed-nav-visible');
        }
      }

      if (isProduct) {
        applyPdpCondensed();
        // Re-evaluate when crossing the desktop breakpoint (e.g. resize/rotate)
        if (pdpDesktopMQ.addEventListener) {
          pdpDesktopMQ.addEventListener('change', applyPdpCondensed);
        } else if (pdpDesktopMQ.addListener) {
          pdpDesktopMQ.addListener(applyPdpCondensed); // older browsers
        }
      }

      function getPageHeightThreshold() {
        var pageHeight = document.documentElement.scrollHeight;
        if (isHomepage) return Infinity; // never trigger on homepage desktop
        if (isListingPage) {
          // Listing pages (collection + search): show condensed nav as soon as main nav scrolls away
          var headerWrapper = document.querySelector('.header-v2-wrapper');
          return headerWrapper ? headerWrapper.offsetHeight : 200;
        }
        if (isProduct) return 400; // PDP: fixed 400px — past gallery/info area
        return 200; // all other pages: past the full header
      }

      function handleCondensedScroll() {
        // Product pages on DESKTOP: condensed nav is pinned always-on.
        // Keep it visible and skip all scroll-based toggling. Small screens
        // fall through to the original behavior below.
        if (isProduct && pdpDesktopMQ.matches) {
          condensedNav.classList.add('is-visible');
          document.body.classList.add('condensed-nav-visible');
          lastScrollY = window.scrollY;
          return;
        }

       

        var currentScrollY = window.scrollY;
        var direction = currentScrollY < lastScrollY ? 'up' : 'down';
        var threshold = getPageHeightThreshold();

        // Homepage desktop: never show condensed nav
        if (isHomepage && window.innerWidth >= 990) {
          condensedNav.classList.remove('is-visible');
          
          document.body.classList.remove('condensed-nav-visible');
          lastScrollY = currentScrollY;
          upwardDistance = 0;
          return;
        }

        // Haven't scrolled past the threshold yet — hide
        if (currentScrollY < threshold && direction === 'down') {
          condensedNav.classList.remove('is-visible');
          
          document.body.classList.remove('condensed-nav-visible');
          upwardDistance = 0;
          lastScrollY = currentScrollY;
          return;
        }

        // At or near the top: always hide condensed, show full nav
        // Hide as soon as the original primary nav starts becoming visible
        var headerWrapper = document.querySelector('.header-v2-wrapper');
        var primaryNav = document.querySelector('.header-v2__primary-nav');
        var fullHeaderHeight = headerWrapper ? headerWrapper.offsetHeight : 200;
        // Calculate where the primary nav starts (header height minus primary nav height)
        var primaryNavTop = fullHeaderHeight;
        if (headerWrapper && primaryNav) {
          primaryNavTop = primaryNav.offsetTop || (fullHeaderHeight - primaryNav.offsetHeight);
        }
        if (currentScrollY <= primaryNavTop) {
          condensedNav.classList.remove('is-visible');
          
          document.body.classList.remove('condensed-nav-visible');
          upwardDistance = 0;
          lastScrollY = currentScrollY;
          return;
        }

        if (direction === 'up') {
          upwardDistance += (lastScrollY - currentScrollY);
          // Listing pages: show immediately on any scroll-up (past nav)
          // Other pages: require minimum upward distance AND past threshold
          if (isListingPage) {
            // Don't show condensed nav if filters panel is expanded
            if (window.__filtersVisible !== true) {
              condensedNav.classList.add('is-visible');
              document.body.classList.add('condensed-nav-visible');
            }
          } else if (isProduct && currentScrollY > threshold) {
            // Product pages: show immediately on scroll-up if past 400px depth
            condensedNav.classList.add('is-visible');
            document.body.classList.add('condensed-nav-visible');
          } else if (upwardDistance >= scrollThreshold && lastScrollY > threshold) {
            condensedNav.classList.add('is-visible');
            
            document.body.classList.add('condensed-nav-visible');
          }
        } else {
          // Scrolling down — hide immediately
          upwardDistance = 0;
          condensedNav.classList.remove('is-visible');
          
          document.body.classList.remove('condensed-nav-visible');
        }

        lastScrollY = currentScrollY;
      }

      var scrollTicking = false;
      window.addEventListener('scroll', function() {
        if (!scrollTicking) {
          requestAnimationFrame(function() {
            handleCondensedScroll();
            scrollTicking = false;
          });
          scrollTicking = true;
        }
      }, { passive: true });
    }

  });
})();

// ====== Sticky Filter/Sort Bar (Collection pages) ======
// Behavior:
// - Scroll down: filter bar pins to top, condensed nav hidden
// - Scroll up: filter bar hides, condensed nav shows
// - At top of page (sentinel visible): filter bar in normal flow, no sticky
(function() {
  function initStickyFilterBar() {
    var sentinel = document.querySelector('div.sentinel-filter-sort');
    if (!sentinel) return;

    var stickyElement = document.querySelector('.facets-custom-display');
    var target = document.querySelector('details.mobile-facets__disclosure');
    var headerWrapper = document.querySelector('.header-v2-wrapper');

    if (!stickyElement && !target) return;

    var isPinned = false;
    var isHidden = false;
    var lastScrollY = window.scrollY;

    function showFilterBar() {
      if (stickyElement) {
        stickyElement.classList.add('filter-sort-bar__sticky', 'filter-sort-bar__sticky-styling');
        stickyElement.classList.remove('filter-sort-bar__hidden');
      }
      if (target && !target.hasAttribute('open')) {
        target.classList.add('fixed-position');
        target.classList.remove('filter-sort-bar__hidden');
        var summary = target.querySelector('summary');
        if (summary) summary.classList.add('mobile-filter-sort-bar__sticky-styling');
      }
      isPinned = true;
      isHidden = false;
    }

    function hideFilterBar() {
      if (stickyElement) {
        stickyElement.classList.add('filter-sort-bar__hidden');
      }
      if (target && !target.hasAttribute('open')) {
        target.classList.add('filter-sort-bar__hidden');
      }
      isHidden = true;
    }

    function resetFilterBar() {
      isPinned = false;
      isHidden = false;
      if (stickyElement) {
        stickyElement.classList.remove('filter-sort-bar__sticky', 'filter-sort-bar__sticky-styling', 'filter-sort-bar__hidden');
        stickyElement.style.top = '';
      }
      if (target && !target.hasAttribute('open')) {
        target.classList.remove('fixed-position', 'filter-bar-styled-inflow', 'filter-sort-bar__hidden');
        target.style.top = '';
        var summary = target.querySelector('summary');
        if (summary) summary.classList.remove('mobile-filter-sort-bar__sticky-styling');
      }
    }

    // Scroll listener: direction-based show/hide
    var scrollTicking = false;
    window.addEventListener('scroll', function() {
      if (!scrollTicking) {
        requestAnimationFrame(function() {
          var currentScrollY = window.pageYOffset || document.documentElement.scrollTop;
          var sentinelRect = sentinel.getBoundingClientRect();
          var direction = currentScrollY > lastScrollY ? 'down' : 'up';

          // If sentinel is visible (user is at/near top), reset to normal flow
          if (sentinelRect.top >= 0) {
            resetFilterBar();
            lastScrollY = currentScrollY;
            scrollTicking = false;
            return;
          }

          // Sentinel is off-screen — filter bar should be in sticky territory
          if (direction === 'down') {
            // Scrolling down: show filter bar pinned at top
            if (!isPinned || isHidden) {
              showFilterBar();
            }
          } else {
            // Scrolling up: hide filter bar ONLY if filters panel is not expanded
            var filtersExpanded = window.__filtersVisible === true;
            if (isPinned && !isHidden && !filtersExpanded) {
              hideFilterBar();
            }
          }

          // Update aside filters top position when pinned (desktop)
          if (isPinned && !isHidden && window.matchMedia('(min-width: 990px)').matches) {
            var asideFilters = document.querySelector('aside .facets-container');
            if (asideFilters && stickyElement) {
              var filterBarHeight = stickyElement.offsetHeight;
              asideFilters.style.top = (filterBarHeight + 2) + 'px';
            }
          }

          lastScrollY = currentScrollY;
          scrollTicking = false;
        });
        scrollTicking = true;
      }
    }, { passive: true });

    // === Mobile filter drawer: handled by Shopify's menu-drawer component ===
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyFilterBar);
  } else {
    initStickyFilterBar();
  }
})();

// Legacy compat: facets.js calls this after AJAX re-renders.
function stickingTheFilterSortBar() {}
